import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Switch } from 'src/components/Antd';
import {
  //   Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import {
  Field, // itemWrapperErrorDisplayAdaptor
} from 'src/components/RcForm';
import { ErrorDisplay2 } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  Menu,
  enabled,
  menu,
  roots,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage-revamp/constant';
import { checkRoots } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage-revamp/validator';
import MenuSortableTree from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/Menu/Components/MenuTree';
import { sectionProps } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useSelector } from 'react-redux';
// import { EPreviewSize } from '@/src/types/common/SalesChannel';

const M = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _params: {
    saleChannelUuid: string;

    contentUuid: string;
  } = useParams();
  const { contentUuid } = _params;
  const { breakpoint, disabled } = props;

  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });
  const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());
  const menuDisabled = disabled || !isOnPrimaryLanguage;
  return (
    <Wrapper id={Menu} breakpoint={breakpoint}>
      <BlockTitle
        id={Menu}
        title={getI18n('general.hOCTitle.menu')}
        breakpoint={breakpoint}
        headerErrorDependencies={[[menu]]}
        validator={(data) => {
          const menu = get(data, 'menu');
          return checkRoots(menu);
        }}
      />
      <Field
        shouldUpdate={(p, c) => {
          return get(p, [menu]) !== get(c, [menu]);
        }}>
        {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
          const { value } = props;
          const menu = get(value, 'menu');
          const res = checkRoots(menu);

          const errors = get(res, 'errors') || [];
          const hasError = get(res, 'hasError');
          return hasError ? (
            <div style={{ marginBottom: 16 }}>
              <ErrorDisplay2 hasError err={errors} />
            </div>
          ) : null;
        }}
      </Field>

      <Section
        {...{
          size: 'small',
          style: { paddingTop: 0 },
        }}>
        <div className={css.switchContainer}>
          {getI18n('general.hOCTitle.menu')}
          <Field name={[menu, enabled]} valuePropName={'checked'}>
            <Switch disabled={disabled} />
          </Field>
        </div>
        <div className={css.enabledTip}>
          {getI18n('salesChannelContent.index.createproductmenu')}
        </div>
      </Section>

      <Section {...sectionProps}>
        <Field
          shouldUpdate={(p, c) => {
            return get(p, [menu, enabled]) !== get(c, [menu, enabled]);
          }}>
          {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
            const e = getFieldValue([menu, enabled]);

            return e ? (
              <Field name={[menu, roots]}>
                {(props, m) => {
                  const errors = get(m, 'errors') || [];
                  const { value, onChange } = props;
                  const handleOnProductChange = (roots) => {
                    onChange(roots);
                  };

                  const handleOnProductAdd = (node) => {
                    onChange([...(value || []), node]);
                  };
                  // const eP = antdErrorDisplayAdaptor(m);
                  return (
                    <div
                      style={
                        {
                          // paddingBottom:
                          //   !isOnPrimaryLanguage || disabled ? '16px' : undefined,
                        }
                      }>
                      <MenuSortableTree
                        linkSet={linkSet}
                        multiLanguageDisabled={menuDisabled}
                        disableEdit={!isOnPrimaryLanguage || disabled}
                        onAdd={handleOnProductAdd}
                        data={value || []}
                        errorList={errors}
                        salesChannelContentUuid={contentUuid}
                        onChange={handleOnProductChange}
                      />
                    </div>
                  );
                }}
              </Field>
            ) : null;
          }}
        </Field>
      </Section>
    </Wrapper>
  );
};
export default M;
